import { modules } from '@/mocks/homeData';

export default function ModulesSection() {
  return (
    <section id="moduller" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-semibold mb-4">
            Modüller
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            İhtiyacınız olan tüm modüller tek sistemde.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Operasyonunuzun her aşaması için özel olarak geliştirilmiş modüller.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {modules.map((mod, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-secondary-200/50 transition-all duration-300 text-center group cursor-default"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 mx-auto flex items-center justify-center bg-secondary-50 rounded-lg mb-3 group-hover:bg-secondary-100 transition-colors duration-300">
                <i className={`${mod.icon} text-secondary-600 text-lg`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 leading-tight">
                {mod.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}